module.exports = __webpack_public_path__ + "static/media/0_2018_11_04.61a08f60.jpg";